/**
* id.ts
* @author Ram Thiru (ramthi)
* @copyright Microsoft 2018
*/
import { createGuid, getLocation, getDocument, safeGetCookieMgr, getCookieValue } from "@microsoft/1ds-core-js";
var Id = /** @class */ (function () {
    function Id(core) {
        this.core = core;
        this.appUserId = null;
        this.firstPageView = false;
        this._cookieMgr = safeGetCookieMgr(core);
        this.lastPageViewId = createGuid();
        this.traceId = this.createTraceId();
    }
    Id.visitorId = function () {
        var userId = getCookieValue(safeGetCookieMgr(null), "MUID");
        return userId;
    };
    Id.prototype.createTraceId = function () {
        return createGuid().replace(/-/g, "");
    };
    Id.prototype.getTraceId = function () {
        return this.traceId;
    };
    Id.prototype.getLastPageViewId = function () {
        return this.lastPageViewId;
    };
    Id.prototype.initializeIds = function () {
        if (!this.firstPageView) {
            this.firstPageView = true;
        }
        else {
            this.traceId = this.createTraceId();
            this.lastPageViewId = createGuid();
        }
    };
    Id.prototype.getMuidUserId = function () {
        var muidValue = getCookieValue(this._cookieMgr, "MUID");
        return muidValue && muidValue.length ? "t:" + muidValue : muidValue;
    };
    /// Set app user id.
    Id.prototype.setAppUserId = function (uid) {
        this.appUserId = null; // Make sure to reset the last user id.
        if (!uid) {
            return; // No need to log null or empty user ids which can be used to reset app user ids.
        }
        for (var i = 0; i < Id.userIdPrefixes.length; i++) {
            if (Id.userIdPrefixes[i] === uid.substring(0, 2)) {
                this.appUserId = uid;
                break;
            }
        }
        if (!this.appUserId) {
            // this._traceLogger.w('Unsupported app user id: ' + uid + '. Supported app user ids are: c:, i:, and w:');
        }
    };
    Id.prototype.setDeviceClass = function (newDeviceClass) {
        if (newDeviceClass) {
            this.deviceClass = newDeviceClass;
        }
    };
    Id.prototype.getDeviceClass = function () {
        return this.deviceClass;
    };
    Id.prototype.getAppUserId = function () {
        return this.appUserId;
    };
    Id.prototype.syncMuid = function (muidHost) {
        var location = getLocation();
        if (location && muidHost) {
            var muidsrc = (location.protocol || "http:") + "//" + muidHost + "/c.gif?DI=4050&did=1&t=";
            var document_1 = getDocument();
            if (document_1) {
                var img = document_1.createElement("IMG");
                img.style.display = "none";
                img.src = muidsrc;
                img.hidden = "";
                img["aria-hidden"] = "true";
                img.role = "presentation";
            }
            return true;
        }
        return false;
    };
    Id.prototype.getMuidHost = function (rootDomain) {
        var supportedMuidHosts = {
            "microsoft.com": "c1.microsoft.com",
            "xbox.com": "c.xbox.com",
            "live.com": "c.live.com",
            "microsoftstore.com": "c.microsoftstore.com",
            "msn.com": "c.msn.com",
            "windows.com": "c.windows.com",
            "office.com": "c.office.com"
        };
        return supportedMuidHosts[rootDomain];
    };
    // Limit support to i, w, and c; make logging accidental PII data more difficult.
    Id.userIdPrefixes = [
        "c:",
        "i:",
        "w:" // domain user id as hash
    ];
    return Id;
}());
export default Id;
//# sourceMappingURL=Id.js.map